import { fetcher } from '@commenda/utils';

import { TAddBillingQuoteLineParams } from './types';

export const addBillingQuoteLine = async (params: TAddBillingQuoteLineParams) => {
  const { quoteId, ...body } = params;
  const response = await fetcher(`commenda-billing/quotes/${quoteId}/lines`, {
    method: 'POST',
    body,
  });

  return response;
};
